import { extractDateTime } from "@/utils/datetime"

const date = new Date()
const tomorrow = new Date(date)
tomorrow.setDate(date.getDate() + 1)

export const db = {
  events: [
    //Pass object from servicesArray in extendedProps
    {
      id: 1,
      url: "",
      title: "Strzyżenie męskie",
      start: (() => { date.setHours(16, 0, 0, 0); return extractDateTime(date) })(),
      end: (() => { date.setHours(17, 0, 0, 0); return extractDateTime(date) })(),
      allDay: false,
      resourceId: "r1",
      extendedProps: {
        calendar: "r1",
        customer: {
          id: 1,
          name: "Luke",
          lastname: "Skywalker",
          note: "Jedi Master",
          blacklist: false,
          marketingAgreement: false,
          tel: "+123456001",
          email: "luke@tatoine.com",
        },
        services: [
          {
            id: 1,
            serviceName: "HaircutXXX",
            price: 50,
            time: 30,
            selectedEmployee:
              {
                "color": "info",
                "label": "Jan Kowalski",
                "id": "r1",
                "imageSource": "",
                "availability": "present",
              },
          },
          {
            id: 4,
            serviceName: "Shave",
            price: 20,
            time: 20,
            selectedEmployee:
              {
                "color": "error",
                "label": "Jan Kowalski",
                "id": "r1",
                "imageSource": "",
                "availability": "present",
              },
          },
        ],
      },
    },
    {
      id: 2,
      url: "",
      title: "Random title",
      start: (() => { date.setHours(13, 0, 0, 0); return extractDateTime(date) })(),
      end: (() => { date.setHours(14, 0, 0, 0); return extractDateTime(date) })(),
      allDay: false,
      resourceId: "r1",
      extendedProps: {
        calendar: "r1",
        customer: {
          id: 3,
          name: "Princess",
          lastname: "Leia",
          note: "General of the Resistance",
          blacklist: false,
          marketingAgreement: false,
          tel: "+123456003",
          email: "princess@princess.com",
        },
        services: [
          { id: 18,
            serviceName: "Pimple popping",
            price: 120, time: 60,
            selectedEmployee:
              {
                "color": "info",
                "label": "Jan Kowalski",
                "id": "r1",
                "imageSource": "",
                "availability": "present",
              },
          },
        ],
      },
    },
    {
      id: 3,
      url: "",
      title: "Koloryzacja brody",
      allDay: false,
      start: (() => { date.setHours(10, 0, 0, 0); return extractDateTime(date) })(),
      end: (() => { date.setHours(11, 0, 0, 0); return extractDateTime(date) })(),
      resourceId: "r3",
      isPaid: true,
      extendedProps: {
        calendar: "r3",
        customer: {
          id: 9,
          name: "C-3PO",
          lastname: "The droid",
          note: "Protocol Droid",
          blacklist: true,
          marketingAgreement: false,
          tel: "+123456009",
          email: "protocol@proto.com",
        },
        services: [
          {
            id: 19,
            serviceName: "Waxing",
            price: 50,
            time: 30,
            selectedEmployee:
              {
                "color": "info",
                "label": "Marcin Wójcik",
                "id": "r3",
                "imageSource": "https://randomuser.me/api/portraits/men/3.jpg",
                "availability": "present",
              },
          },
        ],
      },
    },
    {
      id: 4,
      url: "",
      title: "Strzyżenie męskie",
      start: (() => { tomorrow.setHours(10, 0, 0, 0); return extractDateTime(tomorrow) })(),
      end: (() => { tomorrow.setHours(11, 0, 0, 0); return extractDateTime(tomorrow) })(),
      allDay: false,
      resourceId: "r1",
      extendedProps: {
        calendar: "r1",
        customer: {
          id: 1,
          name: "Luke",
          lastname: "Skywalker",
          note: "Jedi Master",
          blacklist: false,
          marketingAgreement: false,
          tel: "+123456001",
          email: "luke@tatoine.com",
        },
        services: [
          {
            id: 1,
            serviceName: "HaircutXXX",
            price: 50,
            time: 30,
            selectedEmployee:
              {
                "color": "info",
                "label": "Jan Kowalski",
                "id": "r1",
                "imageSource": "",
                "availability": "present",
              },
          },
          {
            id: 4,
            serviceName: "Shave",
            price: 20,
            time: 20,
            selectedEmployee:
              {
                "color": "error",
                "label": "Jan Kowalski",
                "id": "r1",
                "imageSource": "",
                "availability": "present",
              },
          },
        ],
      },
    },


  ],

}
